import type { FaireProductEntity } from "../../entity_types/product";

export const p_19db5d85: FaireProductEntity = {
  token: "p_19db5d85",
  type: "product",
  name: "Good Morning Beautiful Essential Oil Spritz",
  brandToken: "b_d2b124df",
  brandName: "Happy Spritz",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c4d4b285f5fba790086eb1be506705c3ff29eb5adca077a0cd92545dfb23b629/1528223401.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6f5cdc51f66e2d939a3fe953c1cbf6f2b71f5f05a6dc62fccb79185a1f87ead8/1528223346.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/53dcbe94ce3fdc59512fbc15f0597175453cda0153010be694fc459550a4f091/1528223353.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/774dc46d7a8a17ff1ea67c03177f1d262611d626166ff56faefe4fd405326aa6/1528223358.jpg",
    "https://cdn.faire.com/fastly/87e09acfeffe52cfca3f72c667743ce89eb8d941eb5b2344fd43f831512e3e46.jpeg",
    "https://cdn.faire.com/fastly/8a607b257436185b35e54684fd13b96bacdd841ee1938789e9661d153fe3618b.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b5089847cf33e8d2034deb8802ab539e7d32e23cc12511a7ac5f3b2fee430a59/1486076333.jpg",
    "https://cdn.faire.com/fastly/0c4fc89673708b86fed813cf1321f992be39c1d2051aec076c870d5c1d7d6a39.jpeg",
  ],
  priceDollars: 13,
  description:
    "Good Morning Beautiful® essential oil spray is an energizing, uplifting and indulgent blend of organic sweet orange + lemon peel that will keep you feeling rejuvenated and revitalized throughout the day. Great to use first thing in the morning or anytime you are needing an extra boost. \n\n• keynotes: organic sweet orange + lemon peel\n• benefits: energizing, brightening, uplifting, mood boosting\n• ingredients: a proprietary blend of 100% essential oils including organic sweet orange essential oil + lemon essential oil, leucidal liquid (radish root - a natural preservative), poly suga mulse d9 (100% naturally derived emulsifier).\n• use: face + body mist  *avoid direct contact with eyes\n• size: 3.4oz/100ml frosted glass amber bottle\n\nin the details:\n• vegan + cruelty free\n• made in california\na portion of all proceeds goes to benefit animal rescue\n\nPerfect addition to: \nEASTER BASKET\nMOTHER'S DAY GIFTS\nSUMMER TRAVEL ESSENTIALS\nBEACH TRIPS",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:48.469Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
